module.exports = __webpack_public_path__ + "img/channeltalk.5d86f2ed.png";